import React, { useState, useEffect } from 'react';
import { Fade, Stack, Button, Box, IconButton, Grid, Typography, CircularProgress } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useTranslation } from 'react-i18next';


function Photos() {
 const { t: tGlobal } = useTranslation('global');
 const { t: tEvents } = useTranslation('events');
  const [showOverlay, setShowOverlay] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [albumIndex, setalbumIndex] = useState(0);
  const [events, setEvents] = useState([]);
const [loading, setLoading] = useState(true); 
  const [error, setError] = useState(null); 
  useEffect(() => {
    setLoading(true);
    fetch('/data/allEvent.json')
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then((jsonData) => {
        setEvents(jsonData);
        setError(null);
      })
      .catch((error) => {
        console.error('Error loading JSON:', error);
        setError(error.message);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
        <Typography color="error">{tGlobal('Error loading data')}: {error}</Typography>
      </Box>
    );
  }

  if (events.length === 0) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
        <Typography>{tGlobal('No events found')}</Typography>
      </Box>
    );
  }

  const handleOpenOverlay = () => setShowOverlay(true);
  const handleCloseOverlay = () => setShowOverlay(false);

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? events[albumIndex].image.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === events[albumIndex].image.length - 1 ? 0 : prev + 1));
  };

  const handleThumbnailClick = (index) => {
    setCurrentIndex(index);
  };

  return (
    <Stack direction="row" sx={{ justifyContent: "center", minHeight: "65.5vh", backgroundColor: "background.main" }}>
      <Fade in={true} timeout={2000}>
        <Stack direction="column" height="100%" width={{ md: "85%", xs: "100%" }}>
        <Grid marginTop="50px" container spacing={2}>
    {events.toReversed().map((event, idx) => (
      <Grid  item xs={6} sm={6} md={4} lg={3} key={idx}>
        <Box
          onClick={() => {
            setalbumIndex(events.length-idx-1);
            setCurrentIndex(0);
            handleOpenOverlay();
          }}
          sx={{
            position: "relative",
            width: "100%",
            aspectRatio: "1 / 1", // square
            borderRadius: 2,
            overflow: "hidden",
            cursor: "pointer",
            '&:hover .overlay': {
              opacity: 1,
            },
          }}
        >
          {/* Thumbnail image */}
          <Box
            component="img"
            src={event.thumbnail}
            alt={tEvents(event.id+".title")}
            sx={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              transition: "0.3s ease",
            }}
          />

          {/* Hover overlay with title */}
          <Box
  className="overlay"
  sx={{
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.8)",
    color: "white",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    opacity: 0,
    transition: "opacity 0.3s ease",
    overflowY: "auto", // allow scroll for long titles
    textAlign: "center",
    padding: "8px", // padding to prevent clipping
    boxSizing: "border-box",
  }}
>
  <Box
    sx={{
      wordBreak: "break-word",
      whiteSpace: "normal",
      fontWeight: "bold",
      fontSize: "1.1rem",
    }}
  >
    {tEvents(event.id+".title")}
  </Box>
</Box>
        </Box>
      </Grid>
    ))}
  </Grid>

          {showOverlay && (
 <Box
  sx={{
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    bgcolor: 'rgba(0, 0, 0, 0.85)',
    zIndex: 1300,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    px: { xs: 2, sm: 3, md: 4 }, // add padding for small screens
    boxSizing: 'border-box',
  }}
>
  {/* Top info */}
  <Box
  sx={{
    position: 'absolute',
    top: { xs: 12, sm: 16 },
    right: { xs: 12, sm: 24 },
    color: 'white',
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    px: 2,
    py: 0.5,
    borderRadius: '12px',
    fontWeight: 'bold',
    fontSize: { lg: '18px', md: '16px', xs: '12px' },
    maxWidth: 'fit-content',
    zIndex: 2,
    whiteSpace: 'nowrap',
  }}
>
  {currentIndex + 1} / {events[albumIndex].image.length}
</Box>

  {/* Close button */}
  <IconButton
  onClick={handleCloseOverlay}
  sx={{
    position: 'absolute',
    top: { xs: 12, sm: 16 },
    left: { xs: 12, sm: 16 },
    color: 'white',
    zIndex: 2,
  }}
>
  <CloseIcon />
</IconButton>


  {/* Main Image */}
  <Box
  sx={{
    position: 'relative',
    width: '100%',
    maxWidth: 1000, // Allow wider images
    height: { xs: '70vh', sm: '75vh', md: '80vh' }, // Bigger heights
    mb: 2,
    px: { xs: 2, sm: 4 },
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }}
>
  {/* Prev button */}
  <IconButton
    onClick={handlePrev}
    sx={{
      position: 'absolute',
      left: {lg:"-10vw",md:3, xs:"1vw"},
      color: 'white',
      zIndex: 2,
      backgroundColor: 'rgba(0,0,0,0.4)',
      '&:hover': { backgroundColor: 'rgba(0,0,0,0.6)' },
    }}
  >
    <ArrowBackIosNewIcon fontSize="large" />
  </IconButton>

  {/* Main Image */}
  <img
    src={events[albumIndex].image[currentIndex]}
    alt={tEvents(events.id+".title")}
    style={{
      width: '100%',
      height: '100%',
      objectFit: 'contain',
      borderRadius: 10,
    }}
  />

  {/* Next button */}
  <IconButton
  onClick={handleNext}
  sx={{
    position: 'absolute',
    right: {lg:"-10vw", xs: 8, sm: 16 },
    color: 'white',
    zIndex: 2,
    backgroundColor: 'rgba(0,0,0,0.4)',
    '&:hover': { backgroundColor: 'rgba(0,0,0,0.6)' },
  }}
>
  <ArrowForwardIosIcon fontSize="large" />
</IconButton>
</Box>

  {/* Thumbnail scroll bar */}
  <Box sx={{ position: 'relative', width: '90%', maxWidth: 1200 }}>
      <IconButton
        onClick={() => document.getElementById("thumbnail-scroll").scrollBy({ left: -150, behavior: 'smooth' })}
        sx={{ position: 'absolute', left: -10, top: '50%', transform: 'translateY(-50%)', zIndex: 2, color: 'white', bgcolor: 'rgba(0,0,0,0.3)' }}
      >
        <ArrowBackIosNewIcon />
      </IconButton>

      <IconButton
        onClick={() => document.getElementById("thumbnail-scroll").scrollBy({ left: 150, behavior: 'smooth' })}
        sx={{ position: 'absolute', right: -10, top: '50%', transform: 'translateY(-50%)', zIndex: 2, color: 'white', bgcolor: 'rgba(0,0,0,0.3)' }}
      >
        <ArrowForwardIosIcon />
      </IconButton>

      <Box
        id="thumbnail-scroll"
        sx={{
          overflowX: 'auto',
          whiteSpace: 'nowrap',
          py: 1,
          px: 4,
          scrollbarWidth: 'none',
          '&::-webkit-scrollbar': { display: 'none' },
        }}
      >
        {events[albumIndex].image.map((img, index) => (
          <Box
            key={index}
            component="img"
            src={img}
            alt={`Thumb ${index}`}
            onClick={() => handleThumbnailClick(index)}
            sx={{
              width: 80,
              height: 80,
              mx: 1,
              borderRadius: 2,
              border: currentIndex === index ? '3px solid white' : '2px solid transparent',
              cursor: 'pointer',
              objectFit: 'cover',
              display: 'inline-block',
              transition: 'transform 0.3s ease',
              '&:hover': { transform: 'scale(1.05)' },
            }}
          />
        ))}
      </Box>
    </Box>
</Box>
)}
        </Stack>
      </Fade>
    </Stack>
  );
}

export default Photos;